import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router';
class RowItemListSearchPeople extends React.Component {

  chonCongDan(item) {
    this.props.self.hasChange = true;
    this.props.dispatch({
      type: 'CHON_CONG_DAN',
      data: item,
      index: this.props.index
    });
    this.props.dispatch({
      type: 'DISPLAY_FIELD',
      value: true
    });
  }

  xemChiTietCongDan(item) {
    this.props.dispatch({
      type: 'TOGGLE_DIALOG',
      data: {
        name: 'PopupChiTietCongDan',
        status: true
      },
      viewDetailCongDanId: item.congDanId,
      index: this.props.index
    });
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td><Link className="name_popup" onClick={this.xemChiTietCongDan.bind(this, this.props.item)}>{this.props.item.hoVaTen}</Link></td>
        <td>{this.props.item.soCMNDHoChieu}</td>
        <td>{this.props.item.diaChi}</td>
        <td>{this.props.item.soDienThoai}</td>
        <td>{this.props.item.soDonThu}</td>
        <td className="action-center">
            <Link className="icon-check-file" onClick={this.chonCongDan.bind(this, this.props.item)}>Lấy thông tin người đứng đơn</Link>
        </td>
      </tr>
    );
  }
}

function bindStateToProps(state) {
  return {
    index: state.formDataTiepCongDan.index
  };
}

export default connect(bindStateToProps)(RowItemListSearchPeople);



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/add/RowItemListSearchPeople.jsx